import { mobile, tablet } from "../Utils/responsive";
import styled from "styled-components";
import Instagram from "@mui/icons-material/Instagram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import YouTube from "@mui/icons-material/YouTube";
import { FaTiktok } from "react-icons/fa";
import Room from "@mui/icons-material/LocationOn";
import MailOutline from "@mui/icons-material/MailOutline";
import Phone from "@mui/icons-material/Phone";
import LOGO from "../assets/fl.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <ContainerGeral>
      <Container>
        <Left>
          <BrandRow>
            <Logo src={LOGO} />
            <BrandText>
              <BrandName>Felicie Auto</BrandName>
              <BrandSub>Spare Parts LTD</BrandSub>
            </BrandText>
          </BrandRow>

          <Desc>
            FELICIE AUTO SPARE PARTS LTD supplies reliable spare parts with
            professional support for vehicle owners, garages, fleets, and
            institutions in Rwanda.
          </Desc>

          <SocialContainer>
            <a href="https://www.youtube.com/@flcautomo" target="_blank" rel="noopener noreferrer">
              <SocialIcon color="FF0000"><YouTube /></SocialIcon>
            </a>

            <a href="https://www.instagram.com/felicieautospareparts/" target="_blank" rel="noopener noreferrer">
              <SocialIcon color="E4405F"><Instagram /></SocialIcon>
            </a>

            <a href="https://www.tiktok.com/@felicieautospareparts" target="_blank" rel="noopener noreferrer">
              <SocialIcon color="000000"><FaTiktok /></SocialIcon>
            </a>

            <a href="https://www.linkedin.com/company/felicie-auto-spare-part-ltd/" target="_blank" rel="noopener noreferrer">
              <SocialIcon color="0A66C2"><LinkedIn /></SocialIcon>
            </a>
          </SocialContainer>
        </Left>

        <Center>
          <Title>Useful Links</Title>
          <List>
            <ListItem><Link to="/">Home</Link></ListItem>
            <ListItem><Link to="/about">About Us</Link></ListItem>
            <ListItem><Link to="/products">Spare Parts</Link></ListItem>
            <ListItem><Link to="/services">Services</Link></ListItem>
            <ListItem><Link to="/vehicle-sales">Vehicle Sales</Link></ListItem>
            <ListItem><Link to="/car-tracking-system">Car Tracking</Link></ListItem>
            <ListItem><Link to="/blog">Blog</Link></ListItem>
            <ListItem><Link to="/contact">Contact</Link></ListItem>
            <ListItem>
              <a
                href="https://docs.google.com/forms/d/1LiyRbFTkHopwnyXDVyxzlsnVf4hzaPHrtwcBuW0XlZA/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Training & Internship
              </a>
            </ListItem>
          </List>
        </Center>

        <Right>
          <Title>Contact</Title>

          <ContactItem>
            <Room />
            Gikondo, Kicukiro District, Kigali City
          </ContactItem>

          <ContactItem>
            <Phone />
            +250791099925, +250794138398
          </ContactItem>

          <ContactItem>
            <MailOutline />
            info@felicieautospareparts.com
          </ContactItem>

          <CodeLine>Company Code: 124511581</CodeLine>
        </Right>
      </Container>

      {/* ✅ MOBILE-FIXED BOTTOM BAR */}
      <BottomBar>
        <span>
          © {currentYear} FELICIE AUTO SPARE PARTS LTD. All rights reserved.
        </span>
        <span>
          Automotive spare parts specialist in Rwanda
        </span>
      </BottomBar>
    </ContainerGeral>
  );
};

export default Footer;

/* ================= STYLES ================= */

const ContainerGeral = styled.footer`
  color: #dbe8ea;
  background: #071116;
`;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 34px;
  width: 86%;
  margin: 0 auto;
  max-width: 1200px;
  padding: 56px 0 44px;

  ${tablet({ width: "100%" })}
  ${mobile({
    flexDirection: "column",
    padding: "30px 16px",
  })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Logo = styled.img`
  width: 70px;
  height: 70px;
  object-fit: contain;
`;

const BrandText = styled.div`
  display: grid;
  gap: 4px;
`;

const BrandName = styled.span`
  color: #fff;
  font-size: 22px;
  font-weight: 900;
`;

const BrandSub = styled.span`
  color: #37d6ec;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
`;

const Desc = styled.p`
  margin: 20px 0;
  max-width: 380px;
  color: #b8c7cb;
  font-size: 15px;
  line-height: 1.6;
`;

const SocialContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const SocialIcon = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: white;
  background-color: #${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    transition: 0.3s ease;
  }
`;

const Center = styled.div`
  flex: 1;

  ${mobile({ display: "none" })}
`;

const Title = styled.h3`
  margin-bottom: 20px;
  color: #fff;
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  width: 50%;
  margin-bottom: 10px;
  color: #b8c7cb;

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    color: #37d6ec;
  }
`;

const Right = styled.div`
  flex: 1;
`;

const ContactItem = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #b8c7cb;
  line-height: 1.5;
`;

const CodeLine = styled.p`
  margin-top: 10px;
  padding: 10px;
  color: #fff;
  background: rgba(55, 214, 236, 0.12);
  border: 1px solid rgba(55, 214, 236, 0.34);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 800;
`;

const BottomBar = styled.div`
  width: 86%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  color: #8da1a6;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 13px;

  ${mobile({
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "6px",
  })}

  span {
    max-width: 90%;
    line-height: 1.5;
  }
`;
